module.exports = __webpack_public_path__ + "static/media/digital-services.a8c9a063.png";